import { Injectable } from '@angular/core';
import { BBVA_BANK, COUNTRY_CODES } from '@core/constants';
import {
  CardProcessorsEnum,
  PaymentMethodComboBox,
  PaymentMethodModel,
} from '@core/models';
import { SessionState } from '@core/state/shared';
import { environment } from '@env/environment';

@Injectable({
  providedIn: 'root',
})
export class PaymentRequireCvvService {
  private rules: Array<{
    banks?: string[];
    countries?: string[];
    deferred?: boolean;
    hideInProduction?: boolean;
    tokenized?: boolean;
    processors?: string[];
  }> = [
    {
      countries: [COUNTRY_CODES.SV],
      processors: [
        CardProcessorsEnum.AMERICAN_EXPRESS,
        CardProcessorsEnum.AMEX,
      ],
    },
    { banks: BBVA_BANK, deferred: true },
    {
      banks: ['jpmorgan chase bank, n.a.'],
      deferred: true,
      hideInProduction: true,
    },
  ];

  constructor(private sessionState: SessionState) {}

  public isCvvRequired(
    payment?: PaymentMethodComboBox | PaymentMethodModel,
    deferred = false,
    countryCode?: string
  ): 'not-required' | 'required' | 'tokenized' {
    if (!payment) {
      return 'not-required';
    }
    const rulesValues = this.rules.map((rule) => {
        if (
          rule.banks &&
          !rule.banks.includes(payment.bank.toLowerCase() || '')
        ) {
          return 'not-required';
        }
        if (
          rule.countries &&
          !rule.countries.includes(countryCode || this.sessionState.country)
        ) {
          return 'not-required';
        }
        if (rule.deferred !== undefined && rule.deferred !== deferred) {
          return 'not-required';
        }
        if (rule.hideInProduction && environment.production) {
          return 'not-required';
        }
        if (
          rule.processors &&
          !rule.processors.includes(payment.processorName?.toLowerCase() || '')
        ) {
          return 'not-required';
        }

        if (rule.tokenized) {
          return 'tokenized';
        }
        return 'required';
      }),
      requiredRules = rulesValues.filter((rule) => rule !== 'not-required');
    if (requiredRules.length > 0) {
      return requiredRules[0];
    }
    return 'not-required';
  }
}
